export function filterS3ObjectsByFolder(s3Objects, folderName) {
  return folderName
    ? s3Objects.filter(s3Object => {
        return s3Object.Key.startsWith(folderName);
      })
    : s3Objects;
}
